import script from "./CustomChildList.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomChildList.vue?vue&type=script&lang=ts&setup=true"

import "./CustomChildList.vue?vue&type=style&index=0&id=190be58c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-190be58c"]])

export default __exports__